import * as Yup from "yup";

export const smsValidation = Yup.object().shape({
  otpPatern: Yup.string().required("پترن otp الزامی است"),
  sendAcceptedOrderSmsPattern: Yup.string().required(
    "پترن تایید سفارش الزامی است"
  ),
  sendMultipleNumberSmsForArticlePattren: Yup.string().required(
    "پترن ارسال مقاله الزامی است"
  ),
  sendOrderBarcodesSmsPattren: Yup.string().required(
    "پترن دریافت بارکد الزامی است"
  ),
  isDefault: Yup.string().required(" فعال به صورت پیشفرض الزامی است"),
  company: Yup.string().required("شرکت پیامکی الزامی است"),
});
